import { TTBackboneView } from '@/views/TTBackboneView';
import { SignInController } from '@/views/portal/sign_in/SignInController';
import { HeaderUploadResumeWidget } from '@/views/portal/header/HeaderUploadResumeWidget';
import { ServiceCaller } from '@/services/ServiceCaller';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { RecruitmentPortalNavigation } from '@/portal/recruitment/RecruitmentPortalNavigation';

export class HeaderViewController extends TTBackboneView {
	constructor( options = {} ) {
		_.defaults( options, {
			events: {
				'click .company-logo': 'availableJobsClick',
				'click .navbar-signin .login': 'goPortalLogin',
				'click .navbar-signin .logout': 'doLogout',
				'click .navbar-signin .profile': 'goProfile'
				// 'click .navbar-upload-resume > a': 'uploadResume'
			}
		} );

		super( options );
	}

	initialize( options ) {
		super.initialize( options );
		var url;
		var options = {};
		if ( LocalCacheData.getAllURLArgs().company_id ) {
			url = ServiceCaller.getAPIURL( 'Class=APIDocumentPortal&Method=getCompanyLogo' + '&v=2' ) + '&company_id=' + LocalCacheData.getAllURLArgs().company_id + '&X-CSRF-Token=' + encodeURIComponent( getCookie( 'CSRF-Token' ) );
		} else {
			url = '../../theme/default/portal/images/t_icon_logo.png';
		}
		var tpl = Global.loadWidget( 'views/portal/header/HeaderView.html' );
		let portal_vacancy_url = RecruitmentPortalNavigation.getPortalViewURL( 'PortalJobVacancy', {}, { remove_args: [ 'id' ] } );
		this.setElement( _.template( tpl )( { company_logo: url, portal_vacancy_link: portal_vacancy_url } ) );
		this.uploadResumeWidget = null;
		this.profileView = null;
		this.jobVacancyDetailController = null;
		this.jobVacancyViewController = null;
		this.last_rendered_login_state = null;
		this.render();
	}

	getLoginRenderState() {
		var login_user = LocalCacheData.getPortalLoginUser();
		if ( !login_user ) {
			return 'anonymous';
		}

		return [ login_user.id, login_user.first_name, login_user.last_name ].join( ':' );
	}

	render( force ) {
		var $this = this;
		var login_render_state = this.getLoginRenderState();
		if ( force !== true && this.last_rendered_login_state === login_render_state ) {
			return;
		}
		this.last_rendered_login_state = login_render_state;

		var login_user = LocalCacheData.getPortalLoginUser();
		if ( !login_user ) {
			var sign_in_container = $( '<button class="login" type="button"></button>' );
			sign_in_container.append( $( '<img>' ).attr( 'src', '../../theme/default/portal/images/t_icon_head.png' ) );
			sign_in_container.append( $( '<span>' ).text( $.i18n._( 'Sign In' ) ) );
			this.$( '.navbar-signin' ).html( sign_in_container );
		} else {
			var profile_name = $.trim( [login_user.first_name, login_user.last_name].join( ' ' ) );
			if ( profile_name === '' ) {
				profile_name = $.i18n._( 'Profile' );
			}
			var profile_initials = $.trim( ( login_user.first_name || '' ).charAt( 0 ) + ( login_user.last_name || '' ).charAt( 0 ) );
			if ( profile_initials === '' ) {
				profile_initials = profile_name.charAt( 0 );
			}

			var my_profile_container = $( '<div class="dropdown profile-menu"></div>' );
			var profile_toggle = $( '<button class="profile-menu-toggle dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>' );
			profile_toggle.append( $( '<span class="profile-menu-avatar" aria-hidden="true"></span>' ).text( profile_initials ) );
			profile_toggle.append( $( '<span class="profile-menu-name"></span>' ).text( profile_name ) );
			my_profile_container.append( profile_toggle );

			var dropdown_menus = $( '<ul class="dropdown-menu dropdown-menu-end profile-menu-list" aria-labelledby="dropdownMenuButton"></ul>' );
			var profile_menu_item = $( '<a class="profile dropdown-item profile-menu-action"></a>' ).attr( 'href', RecruitmentPortalNavigation.getPortalViewURL( 'MyProfile', {}, { remove_args: [ 'id' ] } ) );
			profile_menu_item.append( $( '<span class="glyphicon glyphicon-user profile-menu-action-icon" aria-hidden="true"></span>' ) );
			profile_menu_item.append( $( '<span></span>' ).text( $.i18n._( 'My Profile' ) ) );
			dropdown_menus.append( $( '<li></li>' ).append( profile_menu_item ) );

			var logout_menu_item = $( '<button type="button" class="logout dropdown-item profile-menu-action"></button>' );
			logout_menu_item.append( $( '<span class="glyphicon glyphicon-log-out profile-menu-action-icon" aria-hidden="true"></span>' ) );
			logout_menu_item.append( $( '<span></span>' ).text( $.i18n._( 'Sign Out' ) ) );
			dropdown_menus.append( $( '<li></li>' ).append( logout_menu_item ) );
			my_profile_container.append( dropdown_menus );
			this.$( '.navbar-signin' ).html( my_profile_container );
		}
	}

	availableJobsClick( e ) {
		return RecruitmentPortalNavigation.handlePortalViewClick( e, 'PortalJobVacancy', {}, { remove_args: [ 'id' ] } );
	}

	goPortalLogin() {
		var sign_controller = new SignInController( {
			_delegate: this.jobVacancyDetailController
		} );
		// $('#signinModal').modal({
		// 	backdrop: 'static',
		// 	show: true
		// });
	}

	doLogout() {
		this.clearErrorTips();
		var $this = this;
		var current_user_api = TTAPI.APIRecruitmentAuthentication;
		current_user_api.Logout( {
			onResult: function( result ) {
				deleteCookie( Global.getSessionIDKey() );
				LocalCacheData.setPortalLoginUser( null );
				LocalCacheData.current_open_view_id = ''; //#1528  -  Logout icon not working.

				if ( $this.jobVacancyViewController ) {
					$this.render();
				} else {
					var url_args = LocalCacheData.getAllURLArgs() || {};
					if ( url_args.m === 'PortalJobVacancy' ) {
						$this.render(); //Ensure the Profile button at the top right switches back to "Sign In"
					} else {
						RecruitmentPortalNavigation.goToPortalView( 'PortalJobVacancy', {}, { replace: true, remove_args: [ 'id' ] } );
					}
				}
			}
		} );
	}

	//needed for logout.
	clearErrorTips() {
		//harder here because we can't access the active controller's data from here.
		Global.removeErrorTips( document.querySelectorAll( '.error-tip' ), true );
	}

	goProfile( e ) {
		this.closeProfileMenu( e );
		return RecruitmentPortalNavigation.handlePortalViewClick( e, 'MyProfile', {}, { remove_args: [ 'id' ] } );
	}

	closeProfileMenu( e ) {
		if ( !e || !e.currentTarget ) {
			return;
		}

		var profile_menu = $( e.currentTarget ).closest( '.profile-menu' );
		var profile_toggle = profile_menu.find( '.profile-menu-toggle' )[0];
		if ( !profile_toggle ) {
			return;
		}

		if ( window.bootstrap && window.bootstrap.Dropdown && typeof window.bootstrap.Dropdown.getOrCreateInstance === 'function' ) {
			window.bootstrap.Dropdown.getOrCreateInstance( profile_toggle ).hide();
			return;
		}

		$( profile_toggle ).removeClass( 'show' ).attr( 'aria-expanded', 'false' );
		profile_menu.find( '.profile-menu-list' ).removeClass( 'show' );
	}

	uploadResume() {
		var $this = this;
		if ( !LocalCacheData.getPortalLoginUser() ) {
			// IndexViewController.instance.router.showTipModal('Please login first!')
			// setTimeout(function(  ) {
			// 	$this.goPortalLogin();
			// }, 100)
			this.goPortalLogin();
		} else {
			if ( !this.uploadResumeWidget ) {
				this.uploadResumeWidget = new HeaderUploadResumeWidget( {
					profileView: $this.profileView
				} );
			}
			this.uploadResumeWidget.render();
		}
	}
}
